<div class="container">
    <div class="row d-flex justify-content-center">
        <div class="col-md-12 text-center">
            <h1>Backtest dinamico 1 anno</h1>
        </div>
    </div>

    <div class="row justify-content-end">
        <div class="col-2 d-flex">
            <input mdbCheckbox type="checkbox" name="onlypos" id="onlypos" class="form-check-input"/><span>Solo positive</span>
        </div>
        <div class="col-2 d-flex flex-row-reverse">
            <button type="button" class="btn btn-primary" mdbButton (click)="calcolaBT()">Esegui BT</button>
        </div>
    </div>
    <div class="row d-flex justify-content-center">
        <div class="col-md-6 text-center">
            <h3>Filtri</h3>
            <form [formGroup]="formFiltri">
            <mdb-form-control class="mb-3">
                <mdb-select formControlName="selMarket" [filter]="true" [visibleOptions]="10">
                  <mdb-option [value]="'all'" (click)="filtraDati()">Tutti i mercati</mdb-option>
                    <mdb-option *ngFor="let option of markets" [value]="option.market" (click)="filtraDati()">{{
                        option.market
                        }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label">Seleziona il Mercato</label>
            </mdb-form-control>
            
            <mdb-form-control class="mb-3">
                <mdb-select formControlName="selDayweek">
                  <mdb-option [value]="0" (click)="filtraDati()">Tutti i giorni</mdb-option>
                    <mdb-option *ngFor="let option of days" [value]="option.value" (click)="filtraDati()">{{
                        option.label
                        }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label">Seleziona il Giorno</label>
            </mdb-form-control>
            
            <mdb-form-control class="mb-3">
                <mdb-select formControlName="selRawal">
                    <mdb-option *ngFor="let option of rawals" [value]="option.value" (click)="filtraDati()">{{
                        option.value
                        }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label">Seleziona il Rawal minimo</label>
            </mdb-form-control>
        </form>
        </div>
    </div>
    <div class="row d-flex justify-content-center">
        <table class="table datatable-table"
        mdbTable
        mdbTableSort
        #table="mdbTable"
        #sort="mdbTableSort"
        [dataSource]="tableData"
        [pagination]="pagination"
        [sort]="sort"
      >
            <thead>
                <tr>
                    <th *ngFor="let header of headers" [mdbTableSortHeader]="header" scope="col">
                      {{ header | titlecase }}
                    </th>
                  </tr>
            </thead>
            <tbody class="datatable-body">
                <tr *ngFor="let r of table.data; let i = index">
                    <td>{{r.market}}</td>
                    <td>{{r.giorno}}</td>
                    <td>{{r.verso}}</td>
                    <td>{{r.swing==0 ? 'Breakout' : 'Swing'}}</td>
                    <td>{{r.num}}</td>
                    <td>{{r.profit | number : '1.4-4'}}</td>
                    <td>{{r.percpos | number :'1.2-2'}}%</td>
                    <td>{{r.profitpip | number : '1.2-2'}}</td>
                    <td>{{r.rawal | number : '1.4-4'}}</td>
                </tr>
            </tbody>
        </table>

        <mdb-table-pagination #pagination></mdb-table-pagination>
    </div>
</div>
